// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"351":"bcfdfff0066203e0","888":"5cd7f8b8b5cbb693"}[chunkId] + ".css";
};